export default __webpack_public_path__ + "c13c8aae792a37ba6d787f8834654cb2.png";